import type { ApiClient } from "./client";
import type { SimulateInboundInput, SimulateInboundResult, SmsSimulatorTarget } from "./types";

/**
 * Development tools. The backend only serves these outside production (AdminIdentity.devTools);
 * the console only offers them when it says so.
 */
export interface DevApi {
  smsSimulator(conversationId: string): Promise<SmsSimulatorTarget>;
  /** Text the store as the seller, delivered like Twilio would (split or one MMS). */
  simulateInbound(conversationId: string, input: SimulateInboundInput): Promise<SimulateInboundResult>;
}

export function createHttpDevApi(client: ApiClient): DevApi {
  return {
    smsSimulator: (id) => client.call("getSmsSimulator", { params: { id } }),
    simulateInbound: (id, input) => client.call("simulateInboundSms", { params: { id }, body: input }),
  };
}
